export const CHARGES_AND_PREPAYMENTS_SET_STATUS =
  'CHARGES_AND_PREPAYMENTS_SET_STATUS';
export const CHARGES_AND_PREPAYMENTS_FETCHING =
  'CHARGES_AND_PREPAYMENTS_FETCHING';
export const CHARGES_AND_PREPAYMENTS_FETCH_ERROR =
  'CHARGES_AND_PREPAYMENTS_FETCH_ERROR';
export const CHARGES_AND_PREPAYMENTS_TOGGLE_ALL_STATUSES =
  'CHARGES_AND_PREPAYMENTS_TOGGLE_ALL_STATUS';
export const CHARGES_AND_PREPAYMENTS_GET_USERS =
  'CHARGES_AND_PREPAYMENTS_GET_USERS';
export const CHARGES_AND_PREPAYMENTS_REPORT = 'CHARGES_AND_PREPAYMENTS_REPORT';
export const CHARGES_AND_PREPAYMENTS_CLEAR_ERRORS =
  'CHARGES_AND_PREPAYMENTS_CLEAR_ERRORS';



// WEBPACK FOOTER //
// ./src/pages/chargesandprepaymentsreport/state/chargesandprepaymentsreport/types.js